import styled from 'styled-components'

export const Wrapper = styled.div<any>`
  text-align: center;
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;

  &::before {
    content: '';
    position: absolute;
    top: ${props => !props.isResults && '-1px'};
    display: block;
    background: ${props => props.theme.palette.general.light};
    height: ${props => props.isReview || props.isLanding || props.isResults ? '40px' : '20px'};
    width: 100%;
    z-index: -1;
    ${props => props.isResults && `
      bottom: -1px;
      background: ${props.theme.palette.general.pink};
      border-radius: 4px 4px 0 0;
    `}
  }

  img {
    width: ${props => props.isReview || props.isLanding || props.isResults ? '80px' : '40px'};
    height: ${props => props.isReview || props.isLanding || props.isResults ? '80px' : '40px'};
  }

  .image-wrapper {
    position: relative;
  }
`

export const Badge = styled.div`
  position: absolute;
  width: 24px;
  height: 24px;
  top: 0;
  right: 0;
  border-radius: 100%;
  overflow: hidden;
  background: ${props => props.theme.productSelector.checkColor};
  display: flex;
  align-items: center;
  justify-content: center;
`
